module.exports = __webpack_public_path__ + "media/images/logo_ponce-a0f9ef91.png";